export const FOLLOW_STATUS_PROFFIT = {
    label: 'proffit内',
    value: 1,
};
export const FOLLOW_STATUS_EXTERNAL = {
    label: 'proffit外',
    value: 2,
};
export const FOLLOW_STATUS_SEND_OFF = {
    label: '見送り',
    value: 3,
};
